import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
  workRest() {
    return request({
      url: store.getters.getPostUrl + 'mes/rest/rest',
      method: 'post'
    })
  },
  workRestTime(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/resttime/rest',
      method: 'post',
	  params:{'workRestId': param}
    })
  },
  timeDivision(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/division/rest',
      method: 'post',
	  params:{'workRestId': param}
    })
  },
  insert1(param) {
	return request({
	  url: store.getters.getPostUrl + 'mes/rest/insert',
	  method: 'post',
	  data:param
	})
  },
  update1(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/rest/update',
  	  method: 'post',
  	  data:param
  	})
  },
  del1(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/rest/delete',
  	 method: 'get',
  	 params:{'id': param}
  	})
  },
  insert2(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/resttime/insert',
  	  method: 'post',
  	  data:param
  	})
  },
  update2(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/resttime/update',
  	  method: 'post',
  	  data:param
  	})
  },
  del2(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/resttime/delete',
  	  method: 'get',
  	  params:{'id': param}
  	})
  },
  insert3(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/division/insert',
  	  method: 'post',
  	  data:param
  	})
  },
  update3(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/division/update',
  	  method: 'post',
  	  data:param
  	})
  },
  del3(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/division/delete',
  	  method: 'get',
  	  params:{'id': param}
  	})
  },
  selectRestList(param) {
  	return request({
  	  url: store.getters.getPostUrl + 'mes/baseRest/selectById',
  	  method: 'post',
  	  params: param
  	})
  },
  saveMaintainRest(param) {
  	return request({
  		url: store.getters.getPostUrl + 'mes/baseRest/update',
  		method: 'post',
  		data: param
  	})
  },
  selectParamById(param) {
	return request({
	  url: store.getters.getPostUrl + 'mes/i18n/paramById',
	  method: 'post',
	  params:{'id': param}
	})
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/timePage/timePage.js